import clsx from 'clsx';
import { MerchandisingSmallBannerContent } from './MerchandisingSmallBannerContent';
import { MerchandisingSmallBannerImage } from './MerchandisingSmallBannerImage';
import { IMerchandisingSmallBannerProps } from '../organisms/MerchandisingSmallBanner/MerchandisingSmallBanner.types';

export const MerchandisingSmallBannerV1 = (props: IMerchandisingSmallBannerProps) => {
  const {
    imageProps,
    descriptionProps,
    buttonProps,
    variationProps,
    isTargetContentError,
    isTargetContentLoaded,
    mathType,
    legalLong,
    customContainerClass,
    colorScheme,
    headerTag,
    headerLong,
    isVariationsAvailable,
  } = props;

  return (
    <div
      className={clsx(
        `merchandising-small-banner t-background-color ${colorScheme} ${customContainerClass}`,
        'd-flex align-items-center flex-column flex-md-row',
        'px-4 pt-0 pt-md-3 pb-4 pb-md-3',
        { 'align-items-md-start': isVariationsAvailable }
      )}
    >
      <MerchandisingSmallBannerImage {...imageProps} />
      <MerchandisingSmallBannerContent
        {...{
          legalLong,
          headerTag,
          headerLong,
          descriptionProps,
          buttonProps,
          variationProps,
          isTargetContentError,
          isTargetContentLoaded,
          mathType,
          isVariationsAvailable,
        }}
      />
    </div>
  );
};
